import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-netto-omzet',
  templateUrl: './spec-netto-omzet.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    NgIf
  ],
  styleUrls: ['./spec-netto-omzet.component.scss']
})
export class SpecNettoOmzetComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public netRevenueFg = {} as FormGroup;
  public revenuesFromSaleOfGoodsFg = {} as FormGroup;
  public revenuesFromProvidingServicesFg = {} as FormGroup;
  public revenuesFromInterestFg = {} as FormGroup;
  public revenuesFromRoyaltiesFg = {} as FormGroup;
  public revenuesFromDividendsFg = {} as FormGroup;
  public revenuesFromLicensesFg = {} as FormGroup;
  public revenuesOtherFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.netRevenueFg = this.jrDataService.createFormGroupBalanceItem()
    this.revenuesFromSaleOfGoodsFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesFromProvidingServicesFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesFromInterestFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesFromRoyaltiesFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesFromDividendsFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesFromLicensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.revenuesOtherFg = this.jrDataService.createFormGroupBalanceItem();
  }

  private patchData(value: JaarrapportageEntity) {

    const nettoOmzet = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.nettoOmzet;

    if (nettoOmzet) {
      this.netRevenueFg.reset();

      if (nettoOmzet.netRevenue) {
        this.netRevenueFg.patchValue(nettoOmzet.netRevenue, {emitEvent: false})
      }

      const uitsplitsing = nettoOmzet.nettoOmzetUitsplitsing;

      if (uitsplitsing) {
        if (uitsplitsing.revenuesFromSaleOfGoods) {
          const subItem = uitsplitsing.revenuesFromSaleOfGoods;
          this.revenuesFromSaleOfGoodsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromSaleOfGoodsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesFromProvidingServices) {
          const subItem = uitsplitsing.revenuesFromProvidingServices;
          this.revenuesFromProvidingServicesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromProvidingServicesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesFromInterest) {
         const subItem = uitsplitsing.revenuesFromInterest;
         this.revenuesFromInterestFg.patchValue(subItem)
         this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromInterestFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesFromRoyalties) {
         const subItem = uitsplitsing.revenuesFromRoyalties;
         this.revenuesFromRoyaltiesFg.patchValue(subItem)
         this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromRoyaltiesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesFromDividends) {
         const subItem = uitsplitsing.revenuesFromDividends;
         this.revenuesFromDividendsFg.patchValue(subItem)
         this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromDividendsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesFromLicenses) {
         const subItem = uitsplitsing.revenuesFromLicenses;
         this.revenuesFromLicensesFg.patchValue(subItem)
         this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesFromLicensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.revenuesOther) {
          const subItem = uitsplitsing.revenuesOther;
          this.revenuesOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.revenuesOtherFg.get('trialBalanceItems') as FormArray)
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    this.revenuesFromSaleOfGoodsFg.updateValueAndValidity();
    this.revenuesFromProvidingServicesFg.updateValueAndValidity();
    this.revenuesFromInterestFg.updateValueAndValidity();
    this.revenuesFromRoyaltiesFg.updateValueAndValidity();
    this.revenuesFromDividendsFg.updateValueAndValidity();
    this.revenuesFromLicensesFg.updateValueAndValidity();
    this.revenuesOtherFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          nettoOmzet: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.nettoOmzet,
            nettoOmzetUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.nettoOmzet?.nettoOmzetUitsplitsing,
              revenuesFromSaleOfGoods: this.revenuesFromSaleOfGoodsFg.value,
              revenuesFromProvidingServices: this.revenuesFromProvidingServicesFg.value,
              revenuesFromInterest: this.revenuesFromInterestFg.value,
              revenuesFromRoyalties: this.revenuesFromRoyaltiesFg.value,
              revenuesFromDividends: this.revenuesFromDividendsFg.value,
              revenuesFromLicenses: this.revenuesFromLicensesFg.value,
              revenuesOther: this.revenuesOtherFg.value,
            },
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
  }
}
